import AdminSubmenu from "../../features/adminSubmenu";
import { FC } from "react";

interface Props { }

const AdminFAQ: FC<Props> = () => {
    return (
            <div>
                <AdminSubmenu />
                <h2 className="mb-3">FAQ AD One</h2>
                <p>
                    För att hämta vilka leverantörer som gäller från AX gäller följande:
                    <ul className="mt-1">
                        <li>
                            I AX, på leverantören, måste KÖPGRUPPEN vara RAT
                        </li>
                        <li>
                            Varje hel timma skriver AX ner uppdaterad leverantörsinfo för hämtning från ADO
                        </li>
                    </ul>
                </p>
                <p>
                    Export till AX:
                    <ul className="mt-1">
                        <li>
                            Efter export till AX bearbetar AX artikel/skapa io/fo underlaget varje 15min med start på hela timma, dvs :00  :15  :30  :45
                        </li>
                    </ul>
                </p>
                <hr />
            </div>
      
    );
};

export default AdminFAQ;
